// Split text into sentences for TTS chunking — used by qwen-tts-sentence-streaming plan.
// Splits on `.`, `?`, `!` followed by whitespace or end-of-string, preserves punctuation.
// Handles common abbreviations (Dr., U.S., $1.2k) — won't split there.
// Merges very short fragments (< 20 chars) into the preceding sentence.

const ABBR_RE = /\b(?:[A-Z]\.(?:\s|$)|Mr\.|Mrs\.|Ms\.|Dr\.|Prof\.|Sr\.|Jr\.|vs\.|etc\.|e\.g\.|i\.e\.|U\.S\.|U\.K\.|[0-9]+\.[0-9]+)/i;

const SHORT_SENTENCE_RE = /^[A-Z][a-z]+$/; // single capitalized word

export function splitIntoSentences(text) {
  const parts = text.split(/(?<=[.!?])\s+/);
  const merged = [];

  for (let i = 0; i < parts.length; i++) {
    const cur = parts[i].trim();
    if (!cur) continue;

    // Check if this is an abbreviation that shouldn't trigger a split on its own period.
    // We only split if the current chunk ends with one of these and doesn't look like
    // the end of a proper sentence (e.g., "Dr." vs "Hello.").
    const dotOnly = /^[A-Za-z]+\.?$/.test(cur) && cur.length <= 5;
    if (dotOnly) {
      // Merge with previous if present, otherwise keep as-is.
      if (merged.length > 0) {
        merged[merged.length - 1] += ' ' + cur;
      } else {
        merged.push(cur);
      }
      continue;
    }

    // If current sentence alone is very short (< 20 chars), merge with previous.
    if (cur.length < 20 && merged.length > 0) {
      merged[merged.length - 1] += ' ' + cur;
    } else {
      merged.push(cur);
    }
  }

  // Post-filter: remove empty entries, trim each.
  return merged.filter(s => s.trim()).map(s => s.trim());
}
